import { useEffect } from "react";

export default function Landing() {
  useEffect(() => { window.location.replace("/landing.html"); }, []);
  return <div style={{ minHeight: "100vh", background: "#F6F3EC" }} />;
}
